import api from '@/store/api'

// Connections are screen state, not shared objects, so they stay out of the
// Vuex object map, and a 403 (capability off) must not bounce to the login page.
const READ = { receive: false, redirectOnForbidden: false, save: false }
const WRITE = { ...READ, delete: false }

const records = response => response.data.data

export const connectedAppsApi = {
  list: () => api.call('GET', 'oauth_connections', {}, READ).then(records),
  disconnect: id => api.call('DELETE', `oauth_connections/${id}`, {}, WRITE).then(records)
}
